import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ExternalPartiesPage } from '@/features/admin';

export const Route = createFileRoute('/_app/admin/external-parties')({
  staticData: { crumb: 'admin:nav.parties' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.users', 'Setup'),
  component: ExternalPartiesPage,
});
